import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { IZendeskCommentEntity } from './interfaces';
import { paginationAdapter } from './zendesk-comments.adapter';

export const {
  ResetLoadingStateMessage,
  ResetPaginationMessage,
  SetLoadingStateMessage,
  UpsertMultiplePagesMessage,
  UpsertPageMessage,
} = paginationAdapter.getMessages();

export const paginationMessages = paginationAdapter.getMessages();

export class UpsertZendeskCommentPageMessage extends UpsertPageMessage {}
export class UpsertZendeskCommentMultiplePagesMessage extends UpsertMultiplePagesMessage {}
export class ResetZendeskCommentPaginationMessage extends ResetPaginationMessage {}

export enum ZendeskCommentMessageTypes {
  SET_COLLECTION = '[ZendeskComment][Message] Set Collection',
  ADD_ONE = '[ZendeskComment][Message] Add One',
  UPDATE_ONE = '[ZendeskComment][Message] Update One',
  UPSERT_ONE = '[ZendeskComment][Message] Upsert One',
  DELETE_ONE = '[ZendeskComment][Message] Delete One',
  ADD_MULTIPLE = '[ZendeskComment][Message] Add All',
  DELETE_MULTIPLE = '[ZendeskComment][Message] Delete Many',
  UPSERT_MULTIPLE = '[ZendeskComment][Message] Upsert Many',
  UPDATE_MULTIPLE = '[ZendeskComment][Message] Update Many',
}
export class SetCollectionMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.SET_COLLECTION;
  constructor(public payload: { entities: IZendeskCommentEntity[] }) {}
}

export class AddOneMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.ADD_ONE;
  constructor(public payload: { entity: IZendeskCommentEntity }) {}
}

export class UpsertOneMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.UPSERT_ONE;
  constructor(public payload: { entity: IZendeskCommentEntity }) {}
}

export class AddMultipleMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.ADD_MULTIPLE;
  constructor(public payload: { entities: IZendeskCommentEntity[] }) {}
}

export class UpsertMultipleMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.UPSERT_MULTIPLE;
  constructor(public payload: { entities: IZendeskCommentEntity[] }) {}
}

export class UpdateOneMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.UPDATE_ONE;
  constructor(public payload: { entity: Update<IZendeskCommentEntity> }) {}
}

export class UpdateMultipleMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.UPDATE_MULTIPLE;
  constructor(public payload: { entities: Update<IZendeskCommentEntity>[] }) {}
}

export class DeleteOneMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.DELETE_ONE;
  constructor(public payload: { id: number }) {}
}

export class DeleteMultipleMessage implements Action {
  readonly type = ZendeskCommentMessageTypes.DELETE_MULTIPLE;
  constructor(public payload: { ids: number[] }) {}
}

export type ZendeskCommentMessages =
  | SetCollectionMessage
  | AddOneMessage
  | UpsertOneMessage
  | AddMultipleMessage
  | UpsertMultipleMessage
  | UpdateOneMessage
  | UpdateMultipleMessage
  | DeleteOneMessage
  | DeleteMultipleMessage;
